import axios from "axios";
import * as config from "./config";
import { Base64 } from "js-base64";
import Helper from "./../extra/helper";
import { v4 as uuidv4 } from "uuid";
import qs from "qs";
import md5 from "md5";

const getToken = () => {
  let token = Helper.getParamUrl();
  if (!token) {
    const tokenPath = window.location.pathname
      .split("/")
      .filter(Boolean)
      ?.pop()
      ?.split(".")
      ?.filter(Boolean)
      ?.pop();

    token = tokenPath;
  }

  return token
}

async function getStime(method, url, data) {
  let token = getToken();
  const res = await axios({
    method: 'GET',
    url: `${config.server_open_api}/v1/products/stime`,
    data: data,
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${token}`,
    },
  });
  return res;
}

const sortObjectByKey = (obj) => {
  const sortedKeys = Object.keys(obj).sort();
  const sortedObject = {};
  sortedKeys.forEach((key) => {
    sortedObject[key] = obj[key];
  });
  return sortedObject;
};

async function callOpenApiNoBase64(method, url, data, useStime = false) {
  let token = getToken();
  let header = {};
  if (useStime) {
    const stimeRes = await getStime(method, url, data);
    if (stimeRes.data.success) {
      const env = process.env.REACT_APP_NODE_ENV;
      const data_ = qs.stringify(sortObjectByKey(data || {}));
      const uuid = uuidv4();
      const client = md5(env + '-' + data_ + stimeRes.data.data.stime + uuid);
      header = {
        'x-api-stime': stimeRes.data.data.stime,
        'x-api-nonce': uuid,
        'x-api-client': client,
      };
    }
  }
  

  const res = await axios({
    method: method,
    url: `${config.server_open_api}${url}`,
    data: data,
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${token}`,
      ...header
    },
  });
  return res;
}

async function apicallNoBase64(method, url, data) {
  let token = getToken();
  const res = await axios({
    method: method,
    url: `${config.server_product}${url}`,
    data: data,
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${token}`,
    },
  });
  return res;
}

async function apicall(method, url, data) {
  let token = getToken();
  const res = await axios({
    method: method,
    url: `${config.server_product}${url}`,
    data: { data: Base64.encode(data) },
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${token}`,
    },
  });
  return res;
}

async function apicall_upload_G2(method, url, data, configCustom) {
  let token = getToken();
  const res = await axios({
    method: method,
    url: `${config.G2Domain}${url}`,
    data: data,
    headers: {
      Authorization: `bearer ${token}`,
    },
    ...configCustom,
  });
  return res;
}


async function apicall_upload(method, url, data, configCustom) {
  console.log('url', config.server_open_api);
  let token = getToken();
  const res = await axios({
    method: method,
    url: `${config.server_open_api}${url}`,
    data: data,
    headers: {
      Authorization: `bearer ${token}`,
    },
    ...configCustom,
  });
  return res;
}

export default {
  apicall,
  apicallNoBase64,
  apicall_upload,
  apicall_upload_G2,
  callOpenApiNoBase64
};
